import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../layout/builders/Layout";
import BuilderConsultantProfile from "./BuilderConsultantProfile";
import BuilderConsultantSubscription from "./BuilderConsultantSubscription";
import BuilderConsultantSubscriptionHistory from "./BuilderConsultantSubscriptionHistory";

const TAB_CONFIG = [
    { key: "profile", label: "Profile" },
    { key: "subscription", label: "Subscription" },
    { key: "history", label: "Sub. History" },
];

const ConsultantManagement = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const tabFromUrl = searchParams.get("tab") || "profile";
    const [activeTab, setActiveTab] = useState(tabFromUrl);

    // Sync tab with URL param
    useEffect(() => {
        const urlTab = searchParams.get("tab") || "profile";
        if (urlTab !== activeTab) {
            setActiveTab(urlTab);
        }
    }, [searchParams]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        setSearchParams({ tab: key });
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case "profile":
                return <BuilderConsultantProfile excludeLayout={true} />;
            case "subscription":
                return <BuilderConsultantSubscription excludeLayout={true} />;
            case "history":
                return <BuilderConsultantSubscriptionHistory excludeLayout={true} />;
            default:
                return <BuilderConsultantProfile excludeLayout={true} />;
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 overflow-x-hidden">
            <Layout>
                <div className="space-y-4 w-full max-w-full px-1 xs:px-2 lg:px-1">


                    {/* Tab Navigation - Admin-style pill tabs */}
                    <div className="bg-white p-2 sm:p-3 rounded-lg shadow-sm border w-full max-w-full overflow-hidden">
                        {/* Mobile (horizontal scroll) */}
                        <div className="flex gap-2 sm:gap-3 overflow-x-auto pb-2 md:hidden scrollbar-hide">
                            {TAB_CONFIG.map((tab) => {
                                const active = activeTab === tab.key;
                                return (
                                    <button
                                        key={tab.key}
                                        onClick={() => handleTabChange(tab.key)}
                                        className={`flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full whitespace-nowrap text-xs sm:text-sm flex-shrink-0 ${active
                                            ? "bg-blue-100 text-blue-600 font-semibold"
                                            : "text-gray-600 bg-gray-100"
                                            }`}
                                    >
                                        {tab.label}
                                    </button>
                                );
                            })}
                        </div>

                        {/* Desktop tabs */}
                        <div className="hidden md:flex flex-wrap gap-3">
                            {TAB_CONFIG.map((tab) => {
                                const active = activeTab === tab.key;
                                return (
                                    <button
                                        key={tab.key}
                                        onClick={() => handleTabChange(tab.key)}
                                        className={`flex items-center gap-2 px-4 py-2 rounded-full ${active
                                            ? "bg-blue-100 text-blue-600 font-semibold"
                                            : "text-gray-600 hover:bg-gray-100"
                                            }`}
                                    >
                                        {tab.label}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="w-full max-w-full overflow-hidden">
                        {renderTabContent()}
                    </div>
                </div>
            </Layout>
        </div>
    );
};

export default ConsultantManagement;
